<div class="igntr-theme max-w-[1280px] mx-auto bg-[--background-color]">
  <div class="p-7 space-y-5">
    <div class="flex items-start justify-between mb-4 flex-wrap gap-2">
      <div class="flex items-start gap-2.5">
        <div
          class="w-8 h-8 rounded-lg bg-white border !border-slate-200 flex items-center justify-center !text-slate-700"
        >
          <igntr-icon name="building"></igntr-icon>
        </div>
        <div>
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ "departments" | transloco }}
          </div>
          <div class="text-[12px] !text-slate-500 mt-0.5">
            {{ departments.length }} {{ "departments" | transloco }}
          </div>
        </div>
      </div>
      <div class="flex items-center gap-3 justify-end">
        <input
          type="text"
          [(ngModel)]="newDepartmentText"
          placeholder="{{ 'enterDepartmentName' | transloco }}"
          class="w-50 text-[14px] !text-slate-800 border !border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:!border-slate-400 ng-untouched ng-pristine ng-valid bg-[white]"
        />
        <button
          class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium inline-flex items-center gap-1.5"
          (click)="addDepartment()"
        >
          <igntr-icon name="plus"></igntr-icon>
          {{ "newDepartment" | transloco }}
        </button>
      </div>
    </div>

    <div
      class="rounded-xl border !border-slate-200/70 bg-white divide-y divide-slate-100"
      *ngIf="departments.length > 0"
    >
      <div
        class="flex items-center gap-3 px-3.5 py-3"
        *ngFor="let department of departments"
      >
        <div
          class="w-8 h-8 rounded-lg bg-slate-100 !text-slate-600 flex items-center justify-center"
        >
          <igntr-icon name="building"></igntr-icon>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-[14px] font-semibold !text-slate-900">
            {{ department.name }}
          </div>
          <!-- <div class="text-[14px] !text-slate-500">
            Head · Allan K. Andreasen
          </div> -->
        </div>
        <!-- <div class="text-right">
          <div class="font-mono text-[14px] !text-slate-900 tabular-nums">
            4
          </div>
          <div class="text-[10px] uppercase tracking-[0.1em] !text-slate-400">
            people
          </div>
        </div> -->
        <button
          class="!text-slate-400 hover:!text-slate-700"
          [matMenuTriggerFor]="menu"
        >
          <igntr-icon name="dots"></igntr-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            class="text-danger"
            (click)="deleteConfirmation = department"
            title="{{ 'delete' | transloco }}"
          >
            {{ "delete" | transloco }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>

<!-- <div class="tenant-tags-container mt-4">
  <h2>Tenant Departments</h2>

  <div class="mb-2">
    <input
      type="text"
      pInputText
      [(ngModel)]="newDepartmentText"
      placeholder="Enter pertment name"
      class="tag-input"
    />
    <button
      pButton
      type="button"
      icon="pi pi-plus"
      (click)="addDepartment()"
      class="ms-2"
    ></button>
  </div>

  <p-table
    #dt1
    [value]="departments"
    class="p-0"
    [globalFilterFields]="['name', 'description']"
  >
    <ng-template pTemplate="header">
      <tr>
        <th [attr.colspan]="innerWidth < 1200 ? 2 : 1">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-search"></i>
            </p-inputgroup-addon>
            <input
              type="text"
              pInputText
              (input)="onGlobalFilter(dt1, $event)"
              placeholder="{{ 'search' | transloco }}"
            />
          </p-inputgroup>
        </th>
        <th class="d-none d-xl-table-cell"></th>
      </tr>
      <tr>
        <th pSortableColumn="title" class="col-6 col-xl-3">
          {{ "title" | transloco }} <p-sortIcon field="title"></p-sortIcon>
        </th>
        <th pSortableColumn="createdAt" class="col-5 col-xl-2">
          {{ "created" | transloco }}
          <p-sortIcon field="createdAt"></p-sortIcon>
        </th>
        <th class="col-1"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-department>
      <tr>
        <td>{{ department.name }}</td>
        <td>{{ department.createdAt | date: "dd-MM-yyyy" }}</td>
        <td>
          <div style="display: flex; justify-content: end">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              tabindex="-1"
              class="small-icon-button d-flex justify-content-center align-items-center p-0"
              style="width: 32px; height: 32px; font-size: 20px; line-height: 1"
            >
              <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                class="text-danger"
                (click)="deleteConfirmation = department"
                title="{{ 'delete' | transloco }}"
              >
                {{ "delete" | transloco }}
              </button>
            </mat-menu>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div> -->
<app-confirm-delete
  id="deleteusermodal"
  *ngIf="deleteConfirmation"
  [deleteCandidate]="deleteConfirmation.name"
  (confirm)="handleDeleteClick(deleteConfirmation); deleteConfirmation = null"
  (cancel)="deleteConfirmation = null"
></app-confirm-delete>
